import { jsx as _jsx } from "react/jsx-runtime";
import { PeopleMovementPage } from './peopleMovement/PeopleMovementPage';
import { RegistryFlagRoute } from './RegistryFlagRoute';
import { CompanyFamilyPage } from './records/CompanyFamilyPage';
import { CompanyRecordPage } from './records/CompanyRecordPage';
import { ContactRecordPage } from './records/ContactRecordPage';
import { GovernmentOrgRecordPage } from './records/GovernmentOrgRecordPage';
import { LaborCategoryAnchorPage } from './records/LaborCategoryAnchorPage';
import { LaborCategoryEntryPage } from './records/LaborCategoryEntryPage';
import { VehicleRecordPage } from './records/VehicleRecordPage';
import { REGISTRY_RECORD_ROUTES } from './registryRecordRoutes';
import { RegistryReviewQueuePage } from './review/RegistryReviewQueuePage';
/**
 * Page per record route. Each page ticket (REG-11 contact, REG-15 company,
 * REG-19/23 labor categories, REG-23 vehicle, REG-25 gov org, REG-30 review
 * queue, REG-33 people movement) swaps its entry here for the real page.
 */ const PAGES = {
    contact: /*#__PURE__*/ _jsx(ContactRecordPage, {}),
    company: /*#__PURE__*/ _jsx(CompanyRecordPage, {}),
    companyFamily: /*#__PURE__*/ _jsx(CompanyFamilyPage, {}),
    lcatEntry: /*#__PURE__*/ _jsx(LaborCategoryEntryPage, {}),
    lcatAnchor: /*#__PURE__*/ _jsx(LaborCategoryAnchorPage, {}),
    vehicle: /*#__PURE__*/ _jsx(VehicleRecordPage, {}),
    govorg: /*#__PURE__*/ _jsx(GovernmentOrgRecordPage, {}),
    reviewQueue: /*#__PURE__*/ _jsx(RegistryReviewQueuePage, {}),
    peopleMovement: /*#__PURE__*/ _jsx(PeopleMovementPage, {})
};
/** The record routes, each behind its flag(s), for the root router. */ export const registryRecordRouteObjects = Object.keys(REGISTRY_RECORD_ROUTES).map((key)=>{
    const def = REGISTRY_RECORD_ROUTES[key];
    return {
        path: def.path,
        element: /*#__PURE__*/ _jsx(RegistryFlagRoute, {
            flag: def.flag,
            alsoRequires: def.alsoRequires,
            fallback: def.fallback,
            children: PAGES[key]
        })
    };
});
